export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pt-BR": {
        "tooltip": {
          "backoffice": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retornar ao backoffice"])};fn.source="Retornar ao backoffice";return fn;})(),
          "account": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecionar Conta"])};fn.source="Selecionar Conta";return fn;})()
        },
        "status": {
          "test": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Teste"])};fn.source="Teste";return fn;})(),
          "inactive": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inativo"])};fn.source="Inativo";return fn;})(),
          "blocked": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bloqueado"])};fn.source="Bloqueado";return fn;})(),
          "active": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativo"])};fn.source="Ativo";return fn;})()
        }
      },
      "en-US": {
        "tooltip": {
          "backoffice": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Return to Backoffice"])};fn.source="Return to Backoffice";return fn;})(),
          "account": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])};fn.source="Select Account";return fn;})()
        },
        "status": {
          "test": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Test"])};fn.source="Test";return fn;})(),
          "inactive": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inactive"])};fn.source="Inactive";return fn;})(),
          "blocked": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blocked"])};fn.source="Blocked";return fn;})(),
          "active": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active"])};fn.source="Active";return fn;})()
        }
      }
    }
  })
}
